import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Space, Typography } from 'antd';
import { MobileOutlined, AppleOutlined, AndroidOutlined } from '@ant-design/icons';
import './styles.css';

const { Title, Paragraph } = Typography;

const AppLinkFallback = () => {
  const { recipeId } = useParams();
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    // Attempt to open the app immediately
    const deepLink = `https://wgts.info/nomnom/recipe/${recipeId}`;
    window.location.href = deepLink;

    // Show fallback UI after a delay if app doesn't open
    const timer = setTimeout(() => {
      setShowFallback(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [recipeId]);

  const handleOpenApp = () => {
    window.location.href = `https://wgts.info/nomnom/recipe/${recipeId}`;
  };

  if (!showFallback) {
    return (
      <div className="app-link-fallback">
        <div className="app-link-fallback-content">
          <MobileOutlined className="app-link-fallback-icon" />
          <Title level={3}>Opening NomNom App...</Title>
        </div>
      </div>
    );
  }

  return (
    <div className="app-link-fallback">
      <div className="app-link-fallback-content">
        <MobileOutlined className="app-link-fallback-icon" />
        <Title level={3}>Open in NomNom App</Title>
        <Paragraph>
          View this recipe in the NomNom mobile app for the best experience.
        </Paragraph>

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Button
            type="primary"
            size="large"
            icon={<MobileOutlined />}
            onClick={handleOpenApp}
            block
          >
            Open in App
          </Button>

          <div className="app-store-links">
            <Paragraph type="secondary">Don't have the app yet?</Paragraph>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Button
                icon={<AppleOutlined />}
                href="https://apps.apple.com/app/id{YOUR_APP_ID}"
                target="_blank"
                block
              >
                Download on App Store
              </Button>
              <Button
                icon={<AndroidOutlined />}
                href="https://play.google.com/store/apps/details?id=com.wgts.nomnom"
                target="_blank"
                block
              >
                Get it on Google Play
              </Button>
            </Space>
          </div>
        </Space>
      </div>
    </div>
  );
};

export default AppLinkFallback;
